/* eslint-disable indent */
import moment from "moment";
const filters = {
  getIcon(val) {
    let icon = "";
    switch (val) {
      case "radio":
        icon = "fa fa-circle-thin";
        break;
      case "checkbox":
        icon = "fa fa-square-o";
        break;
      case "select":
        icon = "fa fa-angle-down";
        break;
    }
    return icon;
  },
  toUpperCase(val) {
    return String(val).toUpperCase();
  },
  formatDate(val, f = "YYYY-MM-DD") {
    return moment(val).format(f);
  },
  formatType(val) {
    const type = {
      offline: "线下调查",
      online: "线上问卷"
    };
    return type[val] || "未知类型";
  },

  getStatusCN(val) {
    let status = "";
    switch (val) {
      case "unpaid":
        status = "未支付";
        break;
      case "auditing":
        status = "审核中";
        break;
      case "ready":
        status = "投放中";
        break;
      case "done":
        status = "已完成";
        break;
      case "cleared":
        status = "已结算";
        break;
      case "editing":
        status = "编辑中";
        break;
      default:
        status = "";
        break;
    }
    return status;
  },
  // surveyStatusCn(val) {
  //   switch (val) {
  //     case 'editing':
  //       return '编辑中'
  //     case 'published':
  //       return '已发布'
  //     default:
  //       return '未知'
  //   }
  // },
  // 转成两位小数的钱的格式
  fixed2Money(val) {
    return val.toFixed(2);
  },
  /** money千分位格式化 */
  formatMoney(val) {
    return (val.toFixed(2) + "").replace(
      /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
      "$&,"
    );
  },

  // CashOut 状态转为中文
  wdStatus(val) {
    let status = "";
    switch (val) {
      case "created":
        status = "审核中";
        break;
      case "audited":
        status = "打款中";
        break;
      case "handled":
        status = "已打款";
        break;
      default:
        return "未知";
    }
    return status;
  },

  surveyStatusCn(val) {
    switch (val) {
      case "started":
        return "已开始";
      case "editing":
        return "编辑中";
      case "stay":
        return "未开始";
      case "published":
        return "收集中";
      case "ended":
        return "已结束";
      default:
        return "未知";
    }
  },

  paipaiStatusCn(val) {
    switch (val) {
      case "stay":
        return "未开始";
      case "published":
        return "已发布";
      case "started":
        return "已开始";
      case "ended":
        return "已结束";
      default:
        return "未知";
    }
  },

  taskStatusCn(val) {
    switch (val) {
      case "started":
        return "已开始";
      case "created":
        return "未开始";
      case "ended":
        return "已结束";
      case "uploaded":
        return "已上传";
      case "confirmed":
        return "已初审";
      case "appealing":
        return "申诉中";
      case "appealed":
        return "已申诉";
      case "reviewing":
        return "复核中";
      case "reviewed":
        return "已复核";
      case "completed":
        return "已完结";
      default:
        return "未知";
    }
  },
  formatAge(val) {
    if (val.join("") === "") {
      return "-";
    }
    const min = val[0];
    const max = val[1];
    if (min && max) {
      return `${min}~${max}岁`;
    }
    if (min) {
      return `≥${min}岁`;
    }
    if (max) {
      return `≤${max}岁`;
    }
  }
};

export default filters;
